<div
  class="part"
  [style.z-index]="cardZIndex"
  (pointerdown)="bringToFront()"
  (focusin)="bringToFront()"
  [ngClass]="{
    left:
      part?.partId?.partType === PartType.LEFT_WING && modelType === 'vector',
    right:
      part?.partId?.partType === PartType.RIGHT_WING && modelType === 'vector',
    'left-scorpion':
      part?.partId?.partType === PartType.LEFT_WING && modelType === 'scorpion',
    'right-scorpion':
      part?.partId?.partType === PartType.RIGHT_WING &&
      modelType === 'scorpion',
    'bottom-left': part?.partId?.partType === PartType.BODY,
    'bottom-right': part?.partId?.partType === PartType.REAR,
    'bottom-right-scorpion':
      part?.partId?.partType === PartType.REAR && modelType === 'scorpion',
  }"
>
  <div class="table-wrapper">
    <div class="title">
      <span class="title-label">
        <span
          class="status-indicator"
          [ngClass]="{
            white: statusIndicator > 25,
            yellow: statusIndicator <= 25 && statusIndicator > 10,
            red: statusIndicator <= 10,
          }"
        ></span>
        {{ displayType }}
      </span>

      @if ((part?.counters?.length ?? 0) > 1) {
        <button
          type="button"
          class="metrics-toggle"
          [attr.aria-expanded]="metricsExpanded"
          [attr.aria-label]="
            (metricsExpanded
              ? 'drone.part.collapse_metrics'
              : 'drone.part.expand_metrics'
            ) | translate
          "
          (click)="toggleMetrics()"
        >
          <mat-icon>
            {{ metricsExpanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>
      }
    </div>
    <div class="table-content">
      <div>{{ 'drone.part.no' | translate }}</div>
      <div>{{ part?.partId?.id }}</div>
      <div>{{ 'drone.part.usage' | translate }}</div>
      <div>{{ getFormattedCounter(part!) }}</div>

      @for (
        counter of part?.counters ?? [];
        track counter.type;
        let index = $index
      ) {
        @if (metricsExpanded) {
          <div class="metric-type">{{ counter.type | translate }}</div>
          <div class="metric-value">
            <span>{{ formatMetricsValueThreshold(counter) }}</span>
            @if (formatMetricPercentage(counter); as percentage) {
              <span
                class="metric-percentage"
                [style.background-color]="getMetricPercentageColor(counter)"
              >
                {{ percentage }}
              </span>
            }
          </div>
        }
      }
    </div>
  </div>
  @switch (part?.partId?.partType) {
    @case (PartType.LEFT_WING) {
      <svg
        width="38"
        height="1"
        viewBox="0 0 38 1"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="top-left-line"
      >
        <path
          d="M0 0.5H38"
          stroke="#969696"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
    @case (PartType.RIGHT_WING) {
      <svg
        width="38"
        height="1"
        viewBox="0 0 38 1"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="top-right-line"
      >
        <path
          d="M0 0.5H38"
          stroke="#969696"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
    @case (PartType.BODY) {
      <svg
        width="179"
        height="40"
        viewBox="0 0 179 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="bottom-left-line"
      >
        <path
          d="M1 39L1 10.5C1 4.97715 5.47715 0.5 11 0.5H260"
          stroke="#969696"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    }
    @case (PartType.REAR) {
      @if (modelType === 'scorpion') {
        <svg
          width="141"
          height="1"
          viewBox="0 0 141 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="bottom-right-line-scorpion"
        >
          <path
            d="M141 0.5H1"
            stroke="#969696"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      } @else {
        <svg
          width="26"
          height="1"
          viewBox="0 0 26 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="bottom-right-line"
        >
          <path
            d="M25 0.5H1"
            stroke="#969696"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
    }
  }
</div>
